import { FC } from "react";
import { Box, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { useKeycloak } from "@Contexts/KeycloakContext";
import { Button } from "@Components/Button";
import { usePageTitle } from "@Hooks/usePageTitle";

export const Logout: FC = () => {
  usePageTitle("Sair");
  const { login, isLoading } = useKeycloak();

  return (
    <Flex minH="100vh" align="center" justify="center" bg="primary.light.base">
      <Box
        bg="neutrals.surface.surface-0"
        borderRadius="16px"
        p="40px"
        w="100%"
        maxW="400px"
        textAlign="center"
        boxShadow="0 8px 32px rgba(0,0,0,0.12)"
      >
        <VStack spacing={6} align="stretch">
          <Box>
            <Heading
              as="h1"
              fontSize="22px"
              fontFamily="heading"
              color="primary.light.base"
            >
              Você saiu
            </Heading>
            <Text
              mt="8px"
              fontSize="sm"
              color="neutrals.text.sub-600"
              fontFamily="body"
            >
              Sua sessão foi encerrada. Para continuar, faça login novamente.
            </Text>
          </Box>

          <Button
            colorSchema="brand"
            onClick={() => login()}
            isLoading={isLoading}
            loadingText="Redirecionando..."
            fullWidth
            h="48px"
            fontSize="16px"
            fontWeight="600"
          >
            Entrar novamente
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};
